import { render } from "./TimeslotComponents.vue?vue&type=template&id=36c358f2&scoped=true"
import script from "./TimeslotComponents.vue?vue&type=script&lang=js"
export * from "./TimeslotComponents.vue?vue&type=script&lang=js"

import "./TimeslotComponents.vue?vue&type=style&index=0&id=36c358f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c358f2"]])

export default __exports__